/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/BiscuitsBundleEvents.ts":
/*!*************************************!*\
  !*** ./src/BiscuitsBundleEvents.ts ***!
  \*************************************/
/***/ (() => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BiscuitBundleEvents = /*#__PURE__*/function () {
  function BiscuitBundleEvents() {
    _classCallCheck(this, BiscuitBundleEvents);
    this.biscuitBundleFormReady = "BiscuitsBundleForm:ready";
    this.biscuitBundleProductReady = "BiscuitsBundleProduct:ready";
    this.biscuitBundleStepReady = "BiscuitsBundleStep:ready";
    this.biscuitBundleStepUpdated = "biscuits--step-update";
    this.init = this.init.bind(this);
    this.listenForBundleFormReady = this.listenForBundleFormReady.bind(this);
    this.listenForBundleStepUpdated = this.listenForBundleStepUpdated.bind(this);
  }
  _createClass(BiscuitBundleEvents, [{
    key: "init",
    value: function init() {
      if (!window.hideBundleCounter) {
        this.listenForBundleFormReady();
        this.listenForBundleStepUpdated();
        document.querySelectorAll("biscuits-bundle-item").forEach(function (step) {
          step.addEventListener("biscuits--product-selection", function (event) {
            console.log("Product Selected", event);
            // Dive into event.detail for the goods
          });
        });
      }
    }
  }, {
    key: "listenForBundleStepUpdated",
    value: function listenForBundleStepUpdated() {
      var _this = this;
      var steps = document.querySelectorAll("biscuits-bundle-step");
      steps.forEach(function (step) {
        var minAmount = step.getAttribute("data-biscuits-maximum-quantity");
        step.addEventListener(_this.biscuitBundleStepUpdated, function (event) {
          var quantityCounter = step.querySelector(".biscuits-bundle-step__counter.biscuits-bundle-step__counter--quantity.biscuit-msg-visible");
          var selectedQuantityEle = quantityCounter.querySelector(".biscuits-bundle-step__quantity");
          var selectedAmount = selectedQuantityEle.textContent;
          if (parseInt(selectedAmount) == parseInt(minAmount)) {
            quantityCounter.classList.add("all-selected");
          } else {
            quantityCounter.classList.remove("all-selected");
          }
          console.log("Step Updated", event);
        });
      });
    }
  }, {
    key: "listenForBundleFormReady",
    value: function listenForBundleFormReady() {
      document.addEventListener(this.biscuitBundleFormReady, function (event) {
        var counters = document.querySelectorAll(".biscuits-bundle-step__counter.biscuits-bundle-step__counter--quantity");
        counters.forEach(function (counter) {
          var counterParent = counter.closest(".biscuits-bundle-step__accordion-content");
          console.log(counterParent);
          var footerMsg = counterParent.querySelector(".biscuits-bundle-step__accordion-footer");
          if (footerMsg) {
            // move the counter to the error message
            counter.classList.add("biscuit-msg-visible");
            footerMsg.appendChild(counter);
          }
        });
      });
    }
  }]);
  return BiscuitBundleEvents;
}();
var biscuitBundleEvents = new BiscuitBundleEvents();
biscuitBundleEvents.init();

/***/ }),

/***/ "./src/CartProgressSection.ts":
/*!************************************!*\
  !*** ./src/CartProgressSection.ts ***!
  \************************************/
/***/ (function() {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var CartProgressSection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CartProgressSection, _HTMLElement);
  function CartProgressSection() {
    var _this;
    _classCallCheck(this, CartProgressSection);
    _this = _callSuper(this, CartProgressSection);
    _this.cartAdd = "on:cart:add";
    _this.lineItemChange = "on:line-item:change";
    _this.cartDrawerRefresh = "dispatch:cart-drawer:refresh";
    _this.cartTotal = Number(_this.dataset.carttotal);
    _this.stepOne = Number(_this.dataset.stepone);
    _this.stepTwo = Number(_this.dataset.steptwo);
    _this.stepThree = Number(_this.dataset.stepthree);
    _this.giftOneDefaultVariantId = _this.dataset.giftonedefault;
    _this.giftTwoDefaultVariantId = _this.dataset.gifttwodefault;
    _this.giftOneQuantity = Number(_this.dataset.giftonequantity);
    _this.giftTwoQuantity = Number(_this.dataset.gifttwoquantity);
    _this.selectedGiftsState = localStorage.getItem("selectedGiftsState") || "{}";
    _this.giftPickerModalTriggers = Array.from(_this.querySelectorAll(".gift-picker-modal-trigger"));
    _this.giftPickerCheckboxes = Array.from(_this.querySelectorAll(".gift-picker-checkbox"));
    _this.giftPickerQuantityWrappers = Array.from(_this.querySelectorAll(".gift-picker-quantity-wrapper"));
    _this.saveChoiceButtons = Array.from(_this.querySelectorAll(".gift-picker-modal-save"));
    _this.attachCartEditListeners = _this.attachCartEditListeners.bind(_assertThisInitialized(_this));
    _this.refreshCartDrawer = _this.refreshCartDrawer.bind(_assertThisInitialized(_this));
    _this.checkCartProgress = _this.checkCartProgress.bind(_assertThisInitialized(_this));
    _this.addProductToCart = _this.addProductToCart.bind(_assertThisInitialized(_this));
    _this.removeProductFromCart = _this.removeProductFromCart.bind(_assertThisInitialized(_this));
    _this.getGiftItemsInCart = _this.getGiftItemsInCart.bind(_assertThisInitialized(_this));
    _this.toggleModal = _this.toggleModal.bind(_assertThisInitialized(_this));
    _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_assertThisInitialized(_this));
    _this.handleQuantityChange = _this.handleQuantityChange.bind(_assertThisInitialized(_this));
    _this.handleSaveChoice = _this.handleSaveChoice.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CartProgressSection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.attachCartEditListeners();
      this.checkCartProgress();
      this.giftPickerModalTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function (event) {
          event.preventDefault();
          _this2.toggleModal(trigger);
        });
      });
      this.giftPickerCheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener("change", function (event) {
          _this2.handleCheckboxChange(checkbox);
        });
      });
      this.giftPickerQuantityWrappers.forEach(function (quantityWrapper) {
        var quantityControlButtons = quantityWrapper.querySelectorAll("button");
        var quantityInput = quantityWrapper.querySelector("input");
        quantityControlButtons.forEach(function (button) {
          button.addEventListener("click", function (event) {
            event.preventDefault();
            _this2.handleQuantityChange(button, quantityInput);
          });
        });
        quantityInput.addEventListener("change", function (event) {
          _this2.handleQuantityChange(null, quantityInput);
        });
      });
      this.saveChoiceButtons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  event.preventDefault();
                  this.handleSaveChoice(button);
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee, this);
          }));
        });
      });
    }
  }, {
    key: "attachCartEditListeners",
    value: function attachCartEditListeners() {
      var _this3 = this;
      document.addEventListener(this.cartAdd, function (event) {
        _this3.refreshCartDrawer();
      });
      document.addEventListener(this.lineItemChange, function (event) {
        _this3.refreshCartDrawer();
      });
    }
  }, {
    key: "refreshCartDrawer",
    value: function refreshCartDrawer() {
      this.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
        bubbles: true
      }));
    }
  }, {
    key: "checkCartProgress",
    value: function checkCartProgress() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var giftItemsInCart, giftOnesInCart, giftTwosInCart, selectedGiftsState, giftsToAdd, giftsToRemove, reloadCartDrawer;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getGiftItemsInCart();
            case 2:
              giftItemsInCart = _context2.sent;
              giftOnesInCart = giftItemsInCart.filter(function (item) {
                return item.giftNumber === 1;
              });
              giftTwosInCart = giftItemsInCart.filter(function (item) {
                return item.giftNumber === 2;
              });
              selectedGiftsState = JSON.parse(this.selectedGiftsState);
              giftsToAdd = [];
              giftsToRemove = []; // Check if the cart total is greater than or equal to the stepOne value
              // If it is, check if giftOne already exists in the selectedGiftsState
              if (this.cartTotal >= this.stepOne) {
                if (!selectedGiftsState.giftOne) {
                  selectedGiftsState.giftOne = this.giftOneDefaultVariantId;
                  giftsToAdd.push({
                    variantId: this.giftOneDefaultVariantId,
                    quantity: this.giftOneQuantity,
                    giftNumber: 1
                  });
                }
              }
              // Check if the cart total is greater than or equal to the stepTwo value
              // If it is, check if giftTwo already exists in the selectedGiftsState
              if (this.cartTotal >= this.stepThree) {
                if (!selectedGiftsState.giftTwo) {
                  selectedGiftsState.giftTwo = this.giftTwoDefaultVariantId;
                  giftsToAdd.push({
                    variantId: this.giftTwoDefaultVariantId,
                    quantity: this.giftTwoQuantity,
                    giftNumber: 2
                  });
                }
              }
              // Delete giftOne from selectedGiftsState if the cart total is less than the stepOne value
              if (this.cartTotal < this.stepOne) {
                if (selectedGiftsState.giftOne) {
                  delete selectedGiftsState.giftOne;
                  giftOnesInCart.forEach(function (item) {
                    giftsToRemove.push(item.key);
                  });
                }
              }
              // Delete giftTwo from selectedGiftsState if the cart total is less than the stepTwo value
              if (this.cartTotal < this.stepThree) {
                if (selectedGiftsState.giftTwo) {
                  delete selectedGiftsState.giftTwo;
                  giftTwosInCart.forEach(function (item) {
                    giftsToRemove.push(item.key);
                  });
                }
              }
              localStorage.setItem("selectedGiftsState", JSON.stringify(selectedGiftsState));
              reloadCartDrawer = true;
              if (!(giftsToAdd.length > 0)) {
                _context2.next = 17;
                break;
              }
              _context2.next = 17;
              return this.addProductToCart(giftsToAdd, reloadCartDrawer);
            case 17:
              if (!(giftsToRemove.length > 0)) {
                _context2.next = 20;
                break;
              }
              _context2.next = 20;
              return this.removeProductFromCart(giftsToRemove, reloadCartDrawer);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "handleSaveChoice",
    value: function handleSaveChoice(button) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var loader, editText, closestGiftPickerModal, giftNumber, pickedVariants, giftItemsToAdd, giftItems, giftItemsToRemove;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loader = button.querySelector(".gift-edit-spinner");
              editText = button.querySelector(".gift-edit-text");
              loader.classList.remove("!tw-hidden");
              editText.classList.add("tw-hidden");
              closestGiftPickerModal = button.closest(".gift-picker-modal");
              giftNumber = Number(closestGiftPickerModal.dataset.giftnumber) || 0; // the picked variants can be seen in the qty-input__input elements. If their value is greater than 0. get their data-variantid
              pickedVariants = Array.from(closestGiftPickerModal.querySelectorAll(".qty-input__input")).filter(function (variant) {
                return Number(variant.value) > 0;
              });
              giftItemsToAdd = pickedVariants.map(function (variant) {
                return {
                  variantId: variant.dataset.variantid,
                  quantity: Number(variant.value),
                  giftNumber: giftNumber
                };
              });
              _context3.next = 10;
              return this.getGiftItemsInCart();
            case 10:
              giftItems = _context3.sent;
              giftItemsToRemove = giftItems.filter(function (item) {
                return item.giftNumber === giftNumber;
              });
              _context3.next = 14;
              return this.addAndRemoveGiftItems(giftItemsToAdd, giftItemsToRemove, button);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "handleQuantityChange",
    value: function handleQuantityChange(button, input) {
      var closestGiftPickerModal = input.closest(".gift-picker-modal");
      var saveChoiceButton = closestGiftPickerModal.querySelector(".gift-picker-modal-save");
      var maxQuantity = Number(closestGiftPickerModal.dataset.maxquantity) || 0;
      var currentTotalQuantity = Number(closestGiftPickerModal.dataset.currentquantity) || 0;
      // Parse the current input value as a starting point
      var quantity = Number(input.value) || 0;
      if (button) {
        var name = button.name;
        // Handle button clicks
        if (name === "plus" && quantity < maxQuantity && currentTotalQuantity < maxQuantity) {
          quantity++;
          currentTotalQuantity++;
          closestGiftPickerModal.dataset.currentquantity = currentTotalQuantity.toString();
        } else if (name === "minus" && quantity > 0 && currentTotalQuantity > 0) {
          quantity--;
          currentTotalQuantity--;
          closestGiftPickerModal.dataset.currentquantity = currentTotalQuantity.toString();
        }
        input.value = quantity.toString();
        if (currentTotalQuantity === maxQuantity) {
          saveChoiceButton.classList.remove("disabled-savebtn");
        } else {
          saveChoiceButton.classList.add("disabled-savebtn");
        }
      }
    }
  }, {
    key: "addProductToCart",
    value: function addProductToCart(productsToAdd, reloadCartDrawer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var items, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              items = [];
              productsToAdd.forEach(function (product) {
                var giftNumber = product.giftNumber;
                items.push({
                  id: product.variantId,
                  quantity: product.quantity,
                  properties: {
                    _gift: "true",
                    _giftNumber: giftNumber.toString()
                  }
                });
              });
              _context4.next = 5;
              return fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  items: items
                })
              });
            case 5:
              response = _context4.sent;
              if (response.ok) {
                _context4.next = 8;
                break;
              }
              throw new Error("Error adding product to cart");
            case 8:
              if (reloadCartDrawer) {
                this.dispatchEvent(new CustomEvent(this.cartDrawerRefresh, {
                  bubbles: true
                }));
              }
              window._conv_q = window._conv_q || [];
              window._conv_q.push(["triggerConversion", "100494738"]);
              _context4.next = 16;
              break;
            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](0);
              console.error(_context4.t0);
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 13]]);
      }));
    }
  }, {
    key: "removeProductFromCart",
    value: function removeProductFromCart(productsToRemove, reloadCartDrawer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var updates, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              updates = {};
              productsToRemove.forEach(function (product) {
                updates[product] = 0;
              });
              _context5.next = 5;
              return fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  updates: updates
                })
              });
            case 5:
              response = _context5.sent;
              if (response.ok) {
                _context5.next = 8;
                break;
              }
              throw new Error("Error removing product from cart");
            case 8:
              if (reloadCartDrawer) {
                this.dispatchEvent(new CustomEvent(this.cartDrawerRefresh, {
                  bubbles: true
                }));
              }
              _context5.next = 14;
              break;
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](0);
              console.error(_context5.t0);
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 11]]);
      }));
    }
  }, {
    key: "getGiftItemsInCart",
    value: function getGiftItemsInCart() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var response, giftItemsInCart, cart, giftItems, giftOneItems, giftTwoItems;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return fetch("/cart.js");
            case 3:
              response = _context6.sent;
              if (response.ok) {
                _context6.next = 6;
                break;
              }
              throw new Error("Error fetching cart");
            case 6:
              giftItemsInCart = [];
              _context6.next = 9;
              return response.json();
            case 9:
              cart = _context6.sent;
              giftItems = cart.items.filter(function (item) {
                return item.properties._gift === "true";
              });
              giftOneItems = giftItems.filter(function (item) {
                return item.properties._giftNumber === "1";
              });
              giftTwoItems = giftItems.filter(function (item) {
                return item.properties._giftNumber === "2";
              }); // create array of gift items in cart, must contain the item.key and giftNumber
              if (giftOneItems.length > 0) {
                giftOneItems.forEach(function (item) {
                  giftItemsInCart.push({
                    key: item.key,
                    giftNumber: 1
                  });
                });
              }
              if (giftTwoItems.length > 0) {
                giftTwoItems.forEach(function (item) {
                  giftItemsInCart.push({
                    key: item.key,
                    giftNumber: 2
                  });
                });
              }
              return _context6.abrupt("return", giftItemsInCart);
            case 18:
              _context6.prev = 18;
              _context6.t0 = _context6["catch"](0);
              console.error(_context6.t0);
            case 21:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 18]]);
      }));
    }
  }, {
    key: "toggleModal",
    value: function toggleModal(trigger) {
      var giftCardComponent = trigger.closest(".gift-card-component");
      var modal = giftCardComponent.querySelector(".gift-picker-modal");
      modal.classList.toggle("giftmodal-visible");
    }
  }, {
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(checkbox) {
      var qunatityControlsWrapper = checkbox.closest(".gift-picker-quantity-controls");
      var checkboxWrapper = qunatityControlsWrapper.querySelector(".gift-picker-checkbox-wrapper");
      var quantityWrapper = qunatityControlsWrapper.querySelector(".gift-picker-quantity-wrapper");
      var checked = checkbox.checked;
      if (checked) {
        checkboxWrapper.classList.add("checkbox-selected");
        quantityWrapper.classList.remove("quantity-hidden");
      } else {
        checkboxWrapper.classList.remove("checkbox-selected");
        quantityWrapper.classList.add("quantity-hidden");
      }
    }
  }, {
    key: "addAndRemoveGiftItems",
    value: function addAndRemoveGiftItems(giftItemsToAdd, giftItemsToRemove, button) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this4 = this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this.removeProductFromCart(giftItemsToRemove.map(function (item) {
                return item.key;
              }), false);
            case 3:
              setTimeout(function () {
                return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return this.addProductToCart(giftItemsToAdd, true);
                      case 2:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7, this);
                }));
              }, 1500);
              _context8.next = 9;
              break;
            case 6:
              _context8.prev = 6;
              _context8.t0 = _context8["catch"](0);
              console.error(_context8.t0);
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 6]]);
      }));
    }
  }]);
  return CartProgressSection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("cart-progress-section", CartProgressSection);

/***/ }),

/***/ "./src/app.ts":
/*!********************!*\
  !*** ./src/app.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _consent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./consent */ "./src/consent.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

// edition sibling title handling
document.addEventListener("DOMContentLoaded", function () {
  var selectedColor = document.getElementById("edition-selected-color");
  var colors = document.querySelectorAll(".edition-sibling");
  var colorsArray = Array.from(colors);
  if (selectedColor) {
    var selectedColorText = selectedColor.innerText;
    var _iterator = _createForOfIteratorHelper(colorsArray),
      _step;
    try {
      var _loop = function _loop() {
        var color = _step.value;
        color.addEventListener("mouseover", function (event) {
          var img = color.querySelector("img");
          var colorText = color.dataset.title;
          selectedColor.innerText = colorText;
          img.style.scale = "1.1";
        });
        color.addEventListener("mouseout", function (event) {
          var img = color.querySelector("img");
          selectedColor.innerText = selectedColorText;
          if (color.classList.contains("selected-sibling") == false) {
            img.style.scale = "1";
          }
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
});
var editionConsent = new _consent__WEBPACK_IMPORTED_MODULE_0__["default"]();
var PurepowerCampaign = /*#__PURE__*/function (_HTMLElement) {
  _inherits(PurepowerCampaign, _HTMLElement);
  function PurepowerCampaign() {
    var _this;
    _classCallCheck(this, PurepowerCampaign);
    _this = _callSuper(this, PurepowerCampaign);
    _this.password = "VIP14";
    _this.elementsToRemoveOnRender = ["#product-grid", ".cc-collection-list", "#lasmere", ".cc-collection-banner", ".breadcrumbs"];
    return _this;
  }
  _createClass(PurepowerCampaign, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // If user has entered password remove the blocker and show the content
      var userHasEnteredPasswordThisSession = sessionStorage.getItem("userHasEnteredPassword");
      if (userHasEnteredPasswordThisSession) {
        this.remove();
        return;
      }
      this.removeElements();
      this.initElements();
      this.addEventListeners();
      console.log("token", this.discountToken);
    }
  }, {
    key: "removeElements",
    value: function removeElements() {
      var _this2 = this;
      setTimeout(function () {
        var _iterator2 = _createForOfIteratorHelper(_this2.elementsToRemoveOnRender),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var selector = _step2.value;
            var element = document.querySelector(selector);
            console.log("element", element);
            if (element) {
              element.remove();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }, 100);
    }
  }, {
    key: "initElements",
    value: function initElements() {
      this.unlockButton = this.querySelector("#unlock-button");
      this.passwordInput = this.querySelector("#password-input");
      this.errorMessage = this.querySelector("#error-message");
      this.successIcon = this.querySelector("#success-icon");
      this.modal = this.querySelector("#unlock-modal");
      this.signupAtag = this.querySelector("#sign-up");
      this.passwordScreen = this.querySelector("#password-screen");
      this.signupScreen = this.querySelector("#signup-screen");
      this.backToPasswordScreen = this.querySelector("#back-to-password-screen");
      this.discountToken = this.dataset.discounttoken;
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this3 = this;
      this.unlockButton.addEventListener("click", function (event) {
        event.preventDefault();
        _this3.handleUnlockButtonClick();
      });
      this.signupAtag.addEventListener("click", function (event) {
        event.preventDefault();
        _this3.handleSignUpAtagClick();
      });
      this.backToPasswordScreen.addEventListener("click", function (event) {
        console.log("back to password screen");
        event.preventDefault();
        _this3.handleBackToPasswordScreenClick();
      });
    }
  }, {
    key: "handleBackToPasswordScreenClick",
    value: function handleBackToPasswordScreenClick() {
      this.togglePasswordScreen();
      this.toggleSignupScreen();
    }
  }, {
    key: "handleSignUpAtagClick",
    value: function handleSignUpAtagClick() {
      this.togglePasswordScreen();
      this.toggleSignupScreen();
    }
  }, {
    key: "togglePasswordScreen",
    value: function togglePasswordScreen() {
      this.passwordScreen.classList.toggle("tw-hidden");
      this.passwordScreen.classList.toggle("tw-flex");
    }
  }, {
    key: "toggleSignupScreen",
    value: function toggleSignupScreen() {
      this.signupScreen.classList.toggle("tw-hidden");
      this.signupScreen.classList.toggle("tw-flex");
    }
  }, {
    key: "handleUnlockButtonClick",
    value: function handleUnlockButtonClick() {
      var password = this.passwordInput.value;
      if (password === this.password) {
        // Show unlock animation and set the cookie and redirect
        this.handleUnlock();
      } else {
        this.handleError();
      }
    }
  }, {
    key: "handleError",
    value: function handleError() {
      var _this4 = this;
      this.errorMessage.classList.remove("tw-hidden");
      this.errorMessage.classList.add("alert-animate");
      setTimeout(function () {
        _this4.errorMessage.classList.remove("alert-animate");
        _this4.errorMessage.classList.add("tw-hidden");
      }, 3000);
    }
  }, {
    key: "handleUnlock",
    value: function handleUnlock() {
      var _this5 = this;
      this.successIcon.classList.remove("tw-hidden");
      this.successIcon.classList.add("tw-flex");
      setTimeout(function () {
        _this5.modal.classList.add("unlock-success");
        setTimeout(function () {
          sessionStorage.setItem("userHasEnteredPassword", "true");
          // Redirect to the currentUrl with the discount added as a url parm
          var currentUrl = window.location.href;
          var url = new URL(currentUrl);
          url.searchParams.set("token", _this5.discountToken);
          // Redirect to the new URL
          window.location.href = url.toString();
        }, 600);
      }, 1200);
    }
  }]);
  return PurepowerCampaign;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("purepower-campaign", PurepowerCampaign);
var DiscountNinja = /*#__PURE__*/function () {
  function DiscountNinja() {
    _classCallCheck(this, DiscountNinja);
    this.init = this.init.bind(this);
  }
  _createClass(DiscountNinja, [{
    key: "init",
    value: function init() {
      this.listenForDiscountNinjaEvents();
    }
  }, {
    key: "listenForDiscountNinjaEvents",
    value: function listenForDiscountNinjaEvents() {
      document.addEventListener("la:dn:cart:updated", function (event) {
        setTimeout(function () {
          // log with gren color
          console.log("%c Edition - DiscountNinja Cart Update available- ", "color: green;");
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: true
          }));
        }, 1500);
      });
    }
  }]);
  return DiscountNinja;
}();
var discountNinja = new DiscountNinja();
discountNinja.init();

/***/ }),

/***/ "./src/consent.ts":
/*!************************!*\
  !*** ./src/consent.ts ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionConsent)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var EditionConsent = /*#__PURE__*/function () {
  function EditionConsent() {
    var _this = this;
    _classCallCheck(this, EditionConsent);
    // declare dataLayer
    this.dataLayer = window.dataLayer || [];
    // Event listener for visitor consent collection - built in Shopify event for visitor consent
    document.addEventListener("visitorConsentCollected", function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var state, visitorConsent;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              state = "update";
              _context.next = 3;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 3:
              visitorConsent = _context.sent;
              console.log(visitorConsent, state);
              this.consentSettings(visitorConsent, state);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    });
    this.updateConsent();
  }
  // methods
  // method to push data to the dataLayer
  // method to update consent settings based on visitorconsent and state
  // method to the fire gtag method with the consent settings from updateConsent method
  _createClass(EditionConsent, [{
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      this.dataLayer.push(arguments);
    }
  }, {
    key: "updateConsent",
    value: function updateConsent() {
      var state = "update";
      if (!window.Shopify.customerPrivacy) return;
      var visitorConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
      console.log(visitorConsent, state);
      this.consentSettings(visitorConsent, state);
    }
  }, {
    key: "consentSettings",
    value: function consentSettings(visitorConsent, state) {
      var consent = {
        functionality_storage: visitorConsent.preferences === "yes" ? "granted" : "granted",
        analytics_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
        personalization_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
        ad_storage: visitorConsent.marketing === "yes" ? "granted" : "denied",
        ad_user_data: visitorConsent.marketing === "yes" ? "granted" : "denied",
        ad_personalization: visitorConsent.marketing === "yes" ? "granted" : "denied",
        wait_for_update: 500
      };
      this.gtag("consent", state, consent);
      // set local Storage for consent settings for further use on other pages or after page refresh
      localStorage.setItem("consentSettings", JSON.stringify(consent));
    }
  }]);
  return EditionConsent;
}();


/***/ }),

/***/ "./src/formatmoney.ts":
/*!****************************!*\
  !*** ./src/formatmoney.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_0__);

function formatMoney(amount) {
  var locale = Shopify.locale;
  var currency = Shopify.currency.active;
  return amount.toLocaleString(locale, {
    style: "currency",
    currency: currency
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formatMoney);

/***/ }),

/***/ "./src/freeGift.ts":
/*!*************************!*\
  !*** ./src/freeGift.ts ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

function getCartData() {
  var _a;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var response, data, totalPrice, lineItems, giftInCart, giftItemKey;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("/cart.json");
        case 3:
          response = _context.sent;
          _context.next = 6;
          return response.json();
        case 6:
          data = _context.sent;
          totalPrice = data.total_price; // check if the cart already has the gift. Done by checking the properties of the line items
          lineItems = data.items;
          console.log("lineItems", lineItems);
          giftInCart = lineItems.some(function (item) {
            if (item.variant_id === window.freeGift) {
              return true;
            }
          });
          if (giftInCart) {
            totalPrice = totalPrice - lineItems.find(function (item) {
              return item.variant_id === window.freeGift;
            }).line_price;
          }
          // find the gift in the line items
          giftItemKey = (_a = lineItems.find(function (item) {
            return item.variant_id === window.freeGift;
          })) === null || _a === void 0 ? void 0 : _a.key;
          return _context.abrupt("return", {
            totalPrice: totalPrice,
            giftInCart: giftInCart,
            giftItemKey: giftItemKey
          });
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 16]]);
  }));
}
function updateCart(updates) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              updates: updates
            })
          });
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return response.json();
        case 6:
          data = _context2.sent;
          _context2.next = 12;
          break;
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9]]);
  }));
}
function checkGift() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var cartData, freeGiftThreshold;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getCartData();
        case 2:
          cartData = _context3.sent;
          freeGiftThreshold = window.freeGiftThreshold;
          if (!(cartData.totalPrice >= freeGiftThreshold)) {
            _context3.next = 8;
            break;
          }
          updateCart(_defineProperty({}, window.freeGift, 1));
          _context3.next = 14;
          break;
        case 8:
          if (!(cartData.totalPrice < freeGiftThreshold)) {
            _context3.next = 13;
            break;
          }
          updateCart(_defineProperty({}, cartData.giftItemKey, 0));
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
              bubbles: true
            }));
          }, 500);
          _context3.next = 14;
          break;
        case 13:
          return _context3.abrupt("return");
        case 14:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
}
// remove the gift on dom load
document.addEventListener("DOMContentLoaded", function () {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var cartData;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(window.cartProgressSectionEnabled === false)) {
            _context4.next = 5;
            break;
          }
          _context4.next = 3;
          return getCartData();
        case 3:
          cartData = _context4.sent;
          if (cartData.giftInCart) {
            updateCart(_defineProperty({}, cartData.giftItemKey, 0));
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
                bubbles: true
              }));
            }, 1000);
          }
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
});
var editionForm = /*#__PURE__*/function (_HTMLElement) {
  _inherits(editionForm, _HTMLElement);
  function editionForm() {
    var _this;
    _classCallCheck(this, editionForm);
    _this = _callSuper(this, editionForm);
    _this.init = _this.init.bind(_assertThisInitialized(_this));
    _this.init();
    return _this;
  }
  _createClass(editionForm, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var checkOutBtn = this.querySelector("button[type='submit']");
      checkOutBtn.addEventListener("click", function (event) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          var cartTerms;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                event.preventDefault();
                cartTerms = document.getElementById("cart-terms");
                if (!(cartTerms.checked && window.cartProgressSectionEnabled === false)) {
                  _context5.next = 8;
                  break;
                }
                _context5.next = 5;
                return checkGift();
              case 5:
                setTimeout(function () {
                  window.location.href = "/checkout";
                }, 1200);
                _context5.next = 9;
                break;
              case 8:
                window.location.href = "/checkout";
              case 9:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
      });
    }
  }]);
  return editionForm;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-form", editionForm);

/***/ }),

/***/ "./src/freeshippingbar.ts":
/*!********************************!*\
  !*** ./src/freeshippingbar.ts ***!
  \********************************/
/***/ (function() {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var freeShippingBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(freeShippingBar, _HTMLElement);
  function freeShippingBar() {
    var _this;
    _classCallCheck(this, freeShippingBar);
    _this = _callSuper(this, freeShippingBar);
    _this.freeShippingThreshold = window.freeShippingThreshold;
    return _this;
  }
  _createClass(freeShippingBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      setTimeout(function () {
        var threshold = _this2.freeShippingThreshold / 100;
        getCart(threshold);
        // listen for changes to the cartItems
        var cartItems = document.querySelector("#cart-items");
        var cartItemsObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            console.log("cart items changed");
            getCart(threshold);
          });
        });
        console.log(cartItems);
        cartItemsObserver.observe(cartItems, {
          attributes: true,
          childList: true,
          characterData: true
        });
      }, 500);
    }
  }]);
  return freeShippingBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-free-shipping-bar", freeShippingBar);
// get the cart
function getCart(threshold) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var response, data, customBarEle, cartTotal, percent, dots, _i, _dots, dot, step, stepNum, bar;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            }
          });
        case 3:
          response = _context.sent;
          if (!response.ok) {
            _context.next = 21;
            break;
          }
          _context.next = 7;
          return response.json();
        case 7:
          data = _context.sent;
          customBarEle = document.querySelector("edition-free-shipping-bar");
          cartTotal = data.total_price;
          cartTotal = cartTotal / 100;
          if (cartTotal === 0) {
            customBarEle.style.display = "none";
          } else {
            customBarEle.style.display = "block";
          }
          // cacluate how much percent is filled
          percent = cartTotal / threshold;
          percent = percent * 100;
          percent = Math.round(percent);
          // get all shipping dots
          dots = Array.from(customBarEle.querySelectorAll(".shipping-dot"));
          for (_i = 0, _dots = dots; _i < _dots.length; _i++) {
            dot = _dots[_i];
            step = dot.dataset.id;
            stepNum = Number(step);
            stepNum <= cartTotal ? dot.classList.add("tw-bg-black") : dot.classList.remove("tw-bg-black");
          }
          // get the bar and fill it
          bar = customBarEle.querySelector("#amount_filled");
          bar.style.width = percent + "%";
          _context.next = 21;
          break;
        case 21:
          _context.next = 26;
          break;
        case 23:
          _context.prev = 23;
          _context.t0 = _context["catch"](0);
          console.error("Error:", _context.t0);
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 23]]);
  }));
}

/***/ }),

/***/ "./src/klaviyoAddedToCart.ts":
/*!***********************************!*\
  !*** ./src/klaviyoAddedToCart.ts ***!
  \***********************************/
/***/ (() => {

/*
import "./types";

document.addEventListener("DOMContentLoaded", () => {
  var _learnq = window._learnq || [];

  let item: Item = {} as Item;

  (function (ns, fetch) {
    ns.fetch = async function () {
      const response = await fetch.apply(this, arguments);

      if (`${window.location.origin}/cart/add.js`.includes(response.url)) {
        try {
          const clonedResponse = response.clone();
          const data = await clonedResponse.json();
          console.log("data", data);
          item = { ...data };
          if (klAjax) {
            _learnq.push(["track", "Added to Cart", item]);
          }
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      }
      return response;
    };
  })(window, window.fetch);

  let klAjax = true;
});
*/

/***/ }),

/***/ "./src/mixpdp.ts":
/*!***********************!*\
  !*** ./src/mixpdp.ts ***!
  \***********************/
/***/ (() => {

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
setTimeout(function () {
  var radioBtns = Array.from(document.querySelectorAll('.edition-radio'));
  if (radioBtns.length >= 1) {
    var _iterator = _createForOfIteratorHelper(radioBtns),
      _step;
    try {
      var _loop = function _loop() {
        var radioBtn = _step.value;
        radioBtn.addEventListener('change', function () {
          var value = radioBtn.value;
          var quantityPicker = document.querySelector('form quantity-input .qty-input__input.input');
          // set the value of the quantity picker to our value
          quantityPicker.value = value;
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}, 500);

/***/ }),

/***/ "./src/modalopener.ts":
/*!****************************!*\
  !*** ./src/modalopener.ts ***!
  \****************************/
/***/ (() => {

setTimeout(function () {
  var modalOpeners = Array.from(document.querySelectorAll('button[data-modalid'));
  var _loop = function _loop() {
    var opener = _modalOpeners[_i];
    opener.addEventListener('click', function (event) {
      var modalId = opener.dataset.modalid;
      var modal = document.querySelector("div[data-modalid=\"".concat(modalId, "\"]"));
      modal.classList.toggle('tw-hidden');
      setTimeout(function () {
        modal.classList.toggle('tw-opacity-0');
      }, 300);
    });
  };
  for (var _i = 0, _modalOpeners = modalOpeners; _i < _modalOpeners.length; _i++) {
    _loop();
  }
  var modalClosers = Array.from(document.querySelectorAll('.edition-modal-close[data-modalid]'));
  var _loop2 = function _loop2() {
    var closer = _modalClosers[_i2];
    closer.addEventListener('click', function (event) {
      var modalId = closer.dataset.modalid;
      var modal = document.querySelector("div[data-modalid=\"".concat(modalId, "\"]"));
      modal.classList.toggle('tw-opacity-0');
      setTimeout(function () {
        modal.classList.toggle('tw-hidden');
      }, 300);
    });
  };
  for (var _i2 = 0, _modalClosers = modalClosers; _i2 < _modalClosers.length; _i2++) {
    _loop2();
  }
}, 500);
//

/***/ }),

/***/ "./src/openCartNote.ts":
/*!*****************************!*\
  !*** ./src/openCartNote.ts ***!
  \*****************************/
/***/ (() => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var editionNote = /*#__PURE__*/function (_HTMLElement) {
  _inherits(editionNote, _HTMLElement);
  function editionNote() {
    var _this;
    _classCallCheck(this, editionNote);
    _this = _callSuper(this, editionNote);
    _this.addEventListener("click", _this.handleClick);
    return _this;
  }
  _createClass(editionNote, [{
    key: "handleClick",
    value: function handleClick(event) {
      var cartNoteElement = document.querySelector("cart-drawer-disclosure");
      var span = cartNoteElement.querySelector("span");
      span.click();
    }
  }]);
  return editionNote;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-note", editionNote);

/***/ }),

/***/ "./src/pickandmix.ts":
/*!***************************!*\
  !*** ./src/pickandmix.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _formatmoney__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formatmoney */ "./src/formatmoney.ts");
/* harmony import */ var _updatecart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./updatecart */ "./src/updatecart.ts");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
// import nessescary types from types.ts

// import the formatMoney function from formatmoney.ts

// import updateCart function from updatecart.ts

// Define the edition-pick-and-mix custom element, which is a wrapper for the pick and mix component on product cards
var editionPickandmix = /*#__PURE__*/function (_HTMLElement) {
  _inherits(editionPickandmix, _HTMLElement);
  function editionPickandmix() {
    _classCallCheck(this, editionPickandmix);
    return _callSuper(this, editionPickandmix);
  }
  _createClass(editionPickandmix, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      setTimeout(function () {
        var bundleBar = document.getElementById("edition-bundle-bar");
        var bundleBarItemsHolder = bundleBar.querySelector("#edition-bundle-bar-items");
        var addToBundle = _this.querySelector(".add_to_bundle");
        addToBundle.addEventListener("click", function (event) {
          addToBundle.style.display = "none";
          var productData = addToBundle.dataset;
          // create a edition-quanity-picker element unless there already is one with the same id
          if (!document.querySelector("edition-quantity-picker[data-id=\"".concat(productData.id, "\"]"))) {
            var qtyPicker = document.createElement("edition-quantity-picker");
            qtyPicker.style.height = "unset;";
            qtyPicker.setAttribute("data-id", productData.id);
            qtyPicker.setAttribute("data-maxqty", productData.inventqty);
            qtyPicker.innerHTML = "\n            <button data-function=\"down\" class=\"edition-qty-decrease\" tw-text-[24px]>-</button>\n              <span class=\"tw-text-[16px] edition-qty\"></span>\n            <button data-function=\"up\" class=\"edition-qty-increase tw-text-[24px]\">+</button>\n            ";
            // append the element edition-pick-and-mix as the previous sibling of the button
            addToBundle.before(qtyPicker);
            var qtyInput = qtyPicker.querySelector(".edition-qty");
            qtyInput.setAttribute("data-qty", "1");
            var bundleElement = document.createElement("edition-pick-and-mix-element");
            // Set data attributes on the element
            bundleElement.setAttribute("data-id", productData.id);
            bundleElement.setAttribute("data-img", productData.img);
            bundleElement.setAttribute("data-price", productData.price);
            bundleElement.setAttribute("data-inventqty", productData.inventqty);
            bundleElement.setAttribute("data-amountinbundle", "1");
            bundleElement.innerHTML = "\n            <div class=\"edition-bundle-bar-image\">\n              <img src=\"".concat(productData.img, "\" />\n            </div>\n            <edition-quantity-picker data-id=\"").concat(productData.id, "\" data-maxqty=\"").concat(productData.inventqty, "\" style=\"height:unset;\">\n              <button data-function=\"down\" class=\"edition-qty-decrease tw-text-[24px]\">-</button>\n                <span class=\"tw-text-[16px] edition-qty\"></span>\n              <button data-function=\"up\" class=\"edition-qty-increase tw-text-[24px]\">+</button>\n            </edition-quantity-picker>\n            ");
            var input = bundleElement.querySelector(".edition-qty");
            input.setAttribute("data-qty", "1");
            // Append the element to the bundlebaritemsholder
            bundleBarItemsHolder.appendChild(bundleElement);
          }
        });
      }, 0);
    }
  }]);
  return editionPickandmix;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-pick-and-mix", editionPickandmix);
// Define the edition-quantity-picker custom element, which is a wrapper for the quantity picker component on product cards
var editionQuantityPicker = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(editionQuantityPicker, _HTMLElement2);
  function editionQuantityPicker() {
    _classCallCheck(this, editionQuantityPicker);
    return _callSuper(this, editionQuantityPicker);
  }
  _createClass(editionQuantityPicker, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // add eventlistener for the custom event edition-qtyinput-change
      // the edition-qtyinput-change event is dispatched when the quantity is changed from all the different quantity pickers
      setTimeout(function () {
        var qtyInput = _this2.querySelector(".edition-qty");
        var dataId = _this2.getAttribute("data-id");
        var allQtyInputs = Array.from(document.querySelectorAll("edition-quantity-picker[data-id=\"".concat(dataId, "\"] .edition-qty")));
        setTimeout(function () {
          document.dispatchEvent(new Event("edition-qtyinput-change"));
        }, 0);
        document.addEventListener("edition-qtyinput-change", function (event) {
          var qty = _this2.querySelector(".edition-qty").getAttribute("data-qty");
          qtyInput.innerText = qty;
          // set the data-amountinbundle attribute on the bundle element
          var bundleElement = _this2.closest("edition-pick-and-mix-element");
          if (bundleElement) {
            bundleElement.setAttribute("data-amountinbundle", qty);
          }
          // if the qty is 0, remove the element
          if (qty == "0") {
            // dispatch the custom event edition-remove-from-bundle
            document.dispatchEvent(new Event("edition-remove-from-bundle"));
          }
          calculatePrices();
        });
        // add eventlistener for the increase and decrease buttons and dispatch the custom event edition-qtyinput-change
        var buttons = Array.from(_this2.querySelectorAll("button"));
        var _loop = function _loop() {
          var button = _buttons[_i];
          button.addEventListener("click", function (event) {
            var functionType = button.dataset["function"];
            var qty = qtyInput.getAttribute("data-qty");
            var maxQty = _this2.getAttribute("data-maxqty");
            var qtyVal = Number(qty);
            var maxQtyVal = Number(maxQty);
            var qtyNumber = functionType == "up" ? qtyVal + 1 : qtyVal - 1;
            // check if the qtyNumber is greater than the maxQtyVal. If it is, set the qtyNumber to the maxQtyVal
            if (qtyNumber > maxQtyVal) {
              qtyNumber = maxQtyVal;
            }
            for (var _i2 = 0, _allQtyInputs = allQtyInputs; _i2 < _allQtyInputs.length; _i2++) {
              var _qtyInput = _allQtyInputs[_i2];
              _qtyInput.setAttribute("data-qty", qtyNumber.toString());
            }
            document.dispatchEvent(new Event("edition-qtyinput-change"));
          });
        };
        for (var _i = 0, _buttons = buttons; _i < _buttons.length; _i++) {
          _loop();
        }
      }, 0);
    }
  }]);
  return editionQuantityPicker;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-quantity-picker", editionQuantityPicker);
// Define the edition-pick-and-mix-element custom element, which is a wrapper for each item in the bundle bar
var editionPickandmixElement = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(editionPickandmixElement, _HTMLElement3);
  function editionPickandmixElement() {
    _classCallCheck(this, editionPickandmixElement);
    return _callSuper(this, editionPickandmixElement);
  }
  _createClass(editionPickandmixElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {}
  }]);
  return editionPickandmixElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("edition-pick-and-mix-element", editionPickandmixElement);
document.addEventListener("edition-remove-from-bundle", function (event) {
  // find all the edition-pick-and-mix who has a button with a data-qty of 0 and remove the tw-opacity-0 class
  var allAddToBundleButtons = Array.from(document.querySelectorAll("edition-pick-and-mix .edition-qty[data-qty=\"0\"]"));
  for (var _i3 = 0, _allAddToBundleButton = allAddToBundleButtons; _i3 < _allAddToBundleButton.length; _i3++) {
    var addToBundleButton = _allAddToBundleButton[_i3];
    var addToBundle = addToBundleButton.closest("edition-pick-and-mix").querySelector(".add_to_bundle");
    addToBundle.classList.remove("tw-opacity-0");
    addToBundle.style.display = "block";
  }
  // find all the edition-pick-and-mix-elements who's children edition-quantity-picker have a qty of 0 and remove them
  var allBundleElements = Array.from(document.querySelectorAll("edition-pick-and-mix-element[data-id]"));
  for (var _i4 = 0, _allBundleElements = allBundleElements; _i4 < _allBundleElements.length; _i4++) {
    var bundleElement = _allBundleElements[_i4];
    var qty = bundleElement.querySelector(".edition-qty").getAttribute("data-qty");
    if (qty == "0") {
      bundleElement.remove();
    }
  }
  // find all the edition-quantity-pickers that have a qty of 0 and remove them
  // the event.target is the document so does not work
  var allQtyPickers = Array.from(document.querySelectorAll("edition-quantity-picker[data-id]"));
  for (var _i5 = 0, _allQtyPickers = allQtyPickers; _i5 < _allQtyPickers.length; _i5++) {
    var qtyPicker = _allQtyPickers[_i5];
    var _qty = qtyPicker.querySelector(".edition-qty").getAttribute("data-qty");
    if (_qty == "0") {
      qtyPicker.remove();
    }
  }
});
function calculatePrices() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var bundleBar, totalComparePriceHolder, totalPriceHolder, totalSavingsHolder, allBundleElements, discountLadder, totalComparePrice, totalAmountInBundle, _i6, _allBundleElements2, bundleElement, comparePrice, amountInBundle, compareTotal, highestDiscountAmount, _iterator, _step, discount, totalPriceWithDiscount, totalDiscount, unitCost;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          bundleBar = document.getElementById("edition-bundle-bar");
          totalComparePriceHolder = bundleBar.querySelector("#edition-pick-and-mix-total-compare-price");
          totalPriceHolder = bundleBar.querySelector("#edition-pick-and-mix-total-price");
          totalSavingsHolder = bundleBar.querySelector("#edition-pick-and-mix-saving-amount");
          allBundleElements = Array.from(document.querySelectorAll("edition-pick-and-mix-element"));
          discountLadder = window.discountLadder; // get the price of each bundle element and calcualte the total compare price
          totalComparePrice = 0;
          totalAmountInBundle = 0;
          for (_i6 = 0, _allBundleElements2 = allBundleElements; _i6 < _allBundleElements2.length; _i6++) {
            bundleElement = _allBundleElements2[_i6];
            comparePrice = Number(bundleElement.getAttribute("data-price"));
            amountInBundle = Number(bundleElement.getAttribute("data-amountinbundle"));
            compareTotal = comparePrice * amountInBundle / 100;
            totalComparePrice += compareTotal;
            totalAmountInBundle += amountInBundle;
          }
          // check totalAmountInBundle is greater than a qty in the discount ladder and get the discount percent that matches
          highestDiscountAmount = 0;
          _iterator = _createForOfIteratorHelper(discountLadder);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              discount = _step.value;
              if (totalAmountInBundle >= discount.quantity && discount.discount > highestDiscountAmount) {
                highestDiscountAmount = discount.discount;
              }
            }
            // apply the discount to the totalComparePrice
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          totalPriceWithDiscount = totalComparePrice - highestDiscountAmount; // calculate the difference between the totalComparePrice and the totalPriceWithDiscount
          totalDiscount = totalComparePrice - totalPriceWithDiscount; // calculate unit cost
          unitCost = totalPriceWithDiscount / totalAmountInBundle; // format the prices using the formatMoney function from formatmoney.ts
          totalComparePriceHolder.textContent = (0,_formatmoney__WEBPACK_IMPORTED_MODULE_1__["default"])(totalComparePrice);
          totalPriceHolder.textContent = (0,_formatmoney__WEBPACK_IMPORTED_MODULE_1__["default"])(totalPriceWithDiscount);
          totalSavingsHolder.textContent = (0,_formatmoney__WEBPACK_IMPORTED_MODULE_1__["default"])(unitCost);
          // if totalAmountInBundle is greater than 0, show the bundle bar
          // if totalAmountInBundle is 0, hide the bundle bar after 700ms
          if (totalAmountInBundle > 0) {
            bundleBar.style.zIndex = "5";
            bundleBar.classList.add("!tw-opacity-100");
            bundleBar.setAttribute("data-amountinbundle", totalAmountInBundle.toString());
          } else {
            bundleBar.classList.remove("!tw-opacity-100");
            bundleBar.removeAttribute("data-amountinbundle");
            setTimeout(function () {
              bundleBar.style.zIndex = "-1";
            }, 700);
          }
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
function addBundleToCart(bundleData) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var response, data, bar, text, spinner, allQtyPickers, _i7, _allQtyPickers2, qtyPicker;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(bundleData)
          });
        case 3:
          response = _context2.sent;
          if (!response.ok) {
            _context2.next = 8;
            break;
          }
          _context2.next = 7;
          return response.json();
        case 7:
          data = _context2.sent;
        case 8:
          if (response.ok) {
            _context2.next = 11;
            break;
          }
          console.log(response);
          throw new Error("Network response was not ok");
        case 11:
          window._conv_q = window._conv_q || [];
          window._conv_q.push(["triggerConversion", "100494738"]);
          _context2.next = 18;
          break;
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](0);
          console.log(_context2.t0);
        case 18:
          _context2.prev = 18;
          // dispatch two custom events to refresh and open the cart drawer (both from the theme itself)
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", {
            bubbles: true
          }));
          // show text and hide spinner
          bar = document.getElementById("edition-bundle-bar");
          text = bar.querySelector(".edition-btn-text");
          spinner = bar.querySelector(".edition-loader");
          text.classList.remove("!tw-opacity-0");
          spinner.classList.remove("!tw-flex");
          // reset all the bundle picker elements
          allQtyPickers = Array.from(document.querySelectorAll(".edition-qty"));
          for (_i7 = 0, _allQtyPickers2 = allQtyPickers; _i7 < _allQtyPickers2.length; _i7++) {
            qtyPicker = _allQtyPickers2[_i7];
            qtyPicker.setAttribute("data-qty", "0");
          }
          document.dispatchEvent(new Event("edition-qtyinput-change"));
          return _context2.finish(18);
        case 30:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 15, 18, 30]]);
  }));
}
setTimeout(function () {
  var editionBundleBar = document.getElementById("edition-bundle-bar");
  if (editionBundleBar) {
    var addBundleToCartButton = editionBundleBar.querySelector("#edition-pick-and-mix-add-bundle-to-cart");
    addBundleToCartButton.addEventListener("click", function (event) {
      // hide text and show spinner
      var bar = document.getElementById("edition-bundle-bar");
      var text = bar.querySelector(".edition-btn-text");
      var spinner = bar.querySelector(".edition-loader");
      text.classList.add("!tw-opacity-0");
      spinner.classList.add("!tw-flex");
      // get all the bundle elements
      var allBundleElements = Array.from(document.querySelectorAll("edition-pick-and-mix-element"));
      // create the bundleData object
      var bundleData = {
        items: []
      };
      // generate a random bundle id of 6 digits
      var randomNum = crypto.getRandomValues(new Uint32Array(1))[0].toString().substring(0, 6);
      for (var _i8 = 0, _allBundleElements3 = allBundleElements; _i8 < _allBundleElements3.length; _i8++) {
        var bundleElement = _allBundleElements3[_i8];
        var id = bundleElement.getAttribute("data-id");
        var qty = bundleElement.getAttribute("data-amountinbundle");
        var collectionTitle = window.collectionTitle;
        var collectionImg = window.collectionImg;
        var collectionUrl = window.collectionUrl;
        var properties = {
          //generate random bundle id of 6 digits
          MixID: randomNum,
          MixTitle: collectionTitle,
          __MixImg: collectionImg,
          MixCollection: collectionUrl
        };
        var item = {
          id: Number(id),
          quantity: Number(qty),
          properties: properties
        };
        bundleData.items.push(item);
      }
      // add the bundle to the cart
      addBundleToCart(bundleData);
      // delete the localStorage item
      localStorage.removeItem("editionBundleData");
    });
  }
}, 500);
document.addEventListener("click", function (event) {
  // get the drawer
  var drawer = document.getElementById("bundle-drawer");
  var target = event.target;
  if (target.classList.contains("create-bundle-drawer")) {
    // setup the empty drawer
    var drawerItemsHolder = drawer.querySelector("#bundle-drawer-items");
    drawerItemsHolder.innerHTML = "";
    // get the button that was clicked
    var btn = target;
    // the dataset contains the data attributes "imgs", "titles" and "qtys"
    // for each of these itteration create a div
    var titles = btn.dataset.titles.split(",");
    var imgs = btn.dataset.imgs.split(",");
    var qtys = btn.dataset.qtys.split(",");
    var keys = btn.dataset.keys.split(",");
    var variantIds = btn.dataset.variantids.split(",");
    var collectionLink = btn.dataset.collection;
    for (var i = 0; i < titles.length; i++) {
      var element = document.createElement("div");
      element.classList.add("bundle-item-wrapper");
      element.setAttribute("data-key", keys[i]);
      element.setAttribute("data-variantid", variantIds[i]);
      element.setAttribute("data-qty", qtys[i]);
      element.innerHTML = "\n        <div class=\"tw-flex tw-flex-col tw-gap-[5px]\">\n          <div class=\"tw-flex tw-justify-center\">\n            <img src=\"".concat(imgs[i], "\" />\n          </div>\n          <div class=\"tw-flex tw-flex-col tw-items-center\">\n            <p class=\"tw-text-center tw-text-[12px] tw-font-bold\">").concat(titles[i], "</p>\n            <p class=\"tw-text-center tw-text-[12px]\">Antal: ").concat(qtys[i], "</p>\n          </div>\n        </div>\n        ");
      drawerItemsHolder.appendChild(element);
    }
    drawer.classList.toggle("tw-hidden");
    setTimeout(function () {
      drawer.style.transform = "translate(0, 0)";
    }, 100);
    // add eventlistner on the close button
    var closeBtn = drawer.querySelector("#bundle-drawer-close");
    closeBtn.addEventListener("click", function (event) {
      drawer.style.transform = "translate(0, 100%)";
      setTimeout(function () {
        drawer.classList.add("tw-hidden");
      }, 750);
    });
    // add eventlistener on the remake bundle button  + store a cookie with the bundle data + redirect to the bundle page
    var remakeBundle = drawer.querySelector("#bundle-remake");
    remakeBundle.addEventListener("click", function (event) {
      // get all the nessescary data (lineItemKeys) from our bundle-item-wrapper elements and create the updates object
      var allBundleItems = Array.from(drawer.querySelectorAll(".bundle-item-wrapper"));
      // get the variantIds and the quantities and store them as an object in localStorage
      var bundleDataForStorage = {};
      for (var _i9 = 0, _allBundleItems = allBundleItems; _i9 < _allBundleItems.length; _i9++) {
        var bundleItem = _allBundleItems[_i9];
        var variantId = bundleItem.getAttribute("data-variantid");
        var qty = bundleItem.getAttribute("data-qty");
        bundleDataForStorage[variantId] = qty;
      }
      // store the bundleDataForStorage in localStorage
      localStorage.setItem("editionBundleData", JSON.stringify(bundleDataForStorage));
      var updates = {};
      // updates must consistof key-value pairs where the key is the lineItemKey and the value is 0
      for (var _i10 = 0, _allBundleItems2 = allBundleItems; _i10 < _allBundleItems2.length; _i10++) {
        var _bundleItem = _allBundleItems2[_i10];
        var key = _bundleItem.getAttribute("data-key");
        updates[key] = 0;
      }
      (0,_updatecart__WEBPACK_IMPORTED_MODULE_2__["default"])(updates);
      // redirect to the bundle page
      setTimeout(function () {
        window.location.href = collectionLink;
      }, 750);
    });
  }
});
// On dom load, check if there is a cookie with bundle data and if there is, create the bundle
document.addEventListener("DOMContentLoaded", function (event) {
  // get the cookie
  var storedBundle = localStorage.getItem("editionBundleData");
  var bundleDataParsed;
  var keys;
  // if the bundle is stored in localStorage , create the bundle
  if (storedBundle) {
    // get the bundleData and parse it
    bundleDataParsed = JSON.parse(storedBundle);
    // get the key from the bundleDataParsed
    keys = Object.keys(bundleDataParsed);
    console.log(bundleDataParsed);
    console.log(keys);
    setTimeout(function () {
      // for each key find the edition-pick-and-mix element who has a button with the same id and click it
      var _iterator2 = _createForOfIteratorHelper(keys),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var addToBundle = document.querySelector(".add_to_bundle[data-id=\"".concat(key, "\"]"));
          if (addToBundle) {
            addToBundle.click();
            // get the edition-quantity-picker element and set the qty
            var qtyPickers = Array.from(document.querySelectorAll("edition-quantity-picker[data-id=\"".concat(key, "\"]")));
            for (var _i11 = 0, _qtyPickers = qtyPickers; _i11 < _qtyPickers.length; _i11++) {
              var qtyPicker = _qtyPickers[_i11];
              var qtyInput = qtyPicker.querySelector(".edition-qty");
              qtyInput.setAttribute("data-qty", bundleDataParsed[key]);
            }
            document.dispatchEvent(new Event("edition-qtyinput-change"));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }, 1000);
  }
});
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
// Theme specific code like moving the bundle bar when specif theme events are fired
setTimeout(function () {
  var bundleBar = document.getElementById("edition-bundle-bar");
  if (bundleBar) {
    // Hide the bundle bar when the cart drawer is opened
    document.addEventListener("dispatch:cart-drawer:open", function (event) {
      bundleBar.style.transition = "transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s";
      bundleBar.style.transform = "translate(-50%, 100%)";
    });
    document.addEventListener("dispatch:cart-drawer:refresh", function (event) {
      // show the bundle bar when the cart drawer is closed
      var overlay = document.querySelector(".overlay.fixed.top-0.right-0.bottom-0.left-0.js-overlay");
      overlay.addEventListener("click", function (event) {
        bundleBar.style.transition = "transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s";
        bundleBar.style.transform = "translate(-50%, -50%)";
      });
      // show the bundle bar when the cart drawer is closed
      document.addEventListener("click", function (event) {
        var target = event.target;
        if (target == document.querySelector(".drawer__close-btn.js-close-drawer")) {
          bundleBar.style.transition = "transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s";
          bundleBar.style.transform = "translate(-50%, -50%)";
        }
      });
      // listen for the keypress escape and show the bundle bar
      document.addEventListener("keydown", function (event) {
        if (event.key == "Escape") {
          bundleBar.style.transition = "transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s";
          bundleBar.style.transform = "translate(-50%, -50%)";
        }
      });
    });
  }
}, 1000);
// add eventlistner on the delete button and delete the bundle / and update the cart
document.addEventListener("click", function (event) {
  var target = event.target;
  if (target.classList.contains("bundle-delete")) {
    var drawer = document.getElementById("bundle-drawer");
    var closestCartDetailsEle = target.closest(".cart-item__details");
    var createBundle = closestCartDetailsEle.querySelector(".create-bundle-drawer");
    createBundle.click();
    // get all the nessescary data (lineItemKeys) from our bundle-item-wrapper elements and create the updates object
    var allBundleItems = Array.from(drawer.querySelectorAll(".bundle-item-wrapper"));
    var updates = {};
    // updates must consistof key-value pairs where the key is the lineItemKey and the value is 0
    for (var _i12 = 0, _allBundleItems3 = allBundleItems; _i12 < _allBundleItems3.length; _i12++) {
      var bundleItem = _allBundleItems3[_i12];
      var key = bundleItem.getAttribute("data-key");
      updates[key] = 0;
    }
    (0,_updatecart__WEBPACK_IMPORTED_MODULE_2__["default"])(updates);
    drawer.style.transform = "translate(0, 100%)";
  }
});

/***/ }),

/***/ "./src/types.ts":
/*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/
/***/ (() => {



/***/ }),

/***/ "./src/updatecart.ts":
/*!***************************!*\
  !*** ./src/updatecart.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
// Import the updates-type from types.ts

// function to update the cart using shopify cart/update.js endpoint
// the function takes in an updates object that contains key-value pairs where the key is a lineitemkey and the value is the desired quantity
function updateCart(updates) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              updates: updates
            })
          });
        case 3:
          response = _context.sent;
          _context.next = 6;
          return response.json();
        case 6:
          data = _context.sent;
          if (response.ok) {
            // dispatch an event to update the cart
            document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
              bubbles: true
            }));
            console.log("cart updated");
          }
          if (!response.ok) {
            console.log(response);
          }
          _context.next = 14;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 14:
          _context.prev = 14;
          return _context.finish(14);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11, 14, 16]]);
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (updateCart);

/***/ }),

/***/ "./src/app.js":
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
/***/ (() => {



/***/ }),

/***/ "./src/app.scss":
/*!**********************!*\
  !*** ./src/app.scss ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkpurepower_multistore"] = self["webpackChunkpurepower_multistore"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/BiscuitsBundleEvents.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/CartProgressSection.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/consent.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/formatmoney.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/freeGift.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/freeshippingbar.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/klaviyoAddedToCart.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/mixpdp.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/modalopener.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/openCartNote.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/pickandmix.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/types.ts")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/updatecart.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;